@if (!isNewEDPScoreboard) {
    <ms-favourite-participant-toggle
        class="participant-favourite"
        [participant]="participant"
        [sport]="event.sport.id"
        [source]="event.offerSource" />
}
<div class="participant-name">
    <div [class.participant-record-picther]="isNewEDPScoreboard && (isPitcherOrRecordsAvailable || !!participantInfo?.rank || participant.country)">
        @if (!isNewEDPScoreboard || !isDoubleParticipant) {
            <div class="participant-name-value" [ngClass]="{ short: vm.logoIsLoaded, truncate: vm.shouldTruncateParticipantName, rank: isShowRank }">
                @if (isNewEDPScoreboard && !!participantInfo?.rank) {
                    <span class="participant-record"> {{ participantInfo?.rank }}</span>
                }
                {{ vm.participantName }}
                @if (participant.country && !isNewEDPScoreboard) {
                    <span class="participant-country"> {{ getParticipantCountry() }}</span>
                }
                @if (showAwayIndicator) {
                    <span class="away-indicator away-indicator-inline" [msAutomation]="'scoreboard-away-indicator'">{{
                        sitecore.globalMessages.AwayIndicator
                    }}</span>
                }
                @if (showAwayIndicator) {
                    <div class="away-indicator away-indicator-stand-alone" [msAutomation]="'scoreboard-away-indicator'">
                        {{ sitecore.globalMessages.AwayIndicator }}
                    </div>
                }
            </div>
        } @else {
            @for (name of doubleParticipantName; track name) {
                <div class="participant-name-value" [ngClass]="{ short: vm.logoIsLoaded, truncate: vm.shouldTruncateParticipantName }">
                    {{ name }}
                </div>
            }
        }

        @if (participant.country && showCountryName && isNewEDPScoreboard) {
            <span class="participant-country"> {{ getParticipantCountry() }}</span>
        }

        @if (isNewEDPScoreboard && !!participantInfo?.winLossStats) {
            <span class="participant-record"> {{ participantInfo?.winLossStats }}</span>
        }

        @if (isNewEDPScoreboard && !!participantInfo?.pitcher) {
            <span class="participant-record"> {{ participantInfo?.pitcher }}</span>
        }
    </div>

    @if (showIndicator && vm.participantLogoUrl) {
        <div class="participant-logo-container" [hidden]="!vm.logoIsLoaded">
            <img class="participant-logo" fill ngSrcset="1x, 2x, 3x" [ngSrc]="vm.participantLogoUrl" (load)="logoLoad()" />
        </div>
    }
</div>
